import React from "react";
import "./../styles/ApplyNowModal.css";
import logo from "./../assets/converted_image.png"; // Update with your logo path

const ApplyNowModal = ({ onClose }) => {
  return (
    <div className="modal-overlay">
      <div className="modal-container">
        {/* Close Button */}
        <button className="close-btn" onClick={onClose}>✖</button>

        <div className="modal-content">
          {/* Left Side Content */}
          <div className="modal-left">
            <p className="modal-message">
              To apply for a new batch, enter your details in the form.
              <br />
              You can also call/WhatsApp us on <br />
              <b>+91 772839373</b>
            </p>
            <img src={logo} alt="Logo" className="modal-logo" />
          </div>

          {/* Right Side Form */}
          <div className="modal-right">
            <h2>Apply Now</h2>
            <form>
              <input type="text" placeholder="Your Name" required />
              <input type="email" placeholder="Your Email" required />
              <input type="tel" placeholder="Your Phone Number" required />
              <textarea placeholder="Message to Us" required></textarea>
              <button type="submit">Submit</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplyNowModal;
